import { NgModule } from '@angular/core';

import { SharedModule } from '@shared/shared.module';
import {
    AuthService,
    ChangePasswordComponent,
    LoginComponent,
} from './auth';

@NgModule({
    declarations: [
        LoginComponent,
        ChangePasswordComponent,
    ],
    imports: [
        SharedModule,
    ],
    providers: [
        AuthService,
    ],
})
export class CoreModule {}
